import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

const AllProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "products"));
        const productList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(productList);
      } catch (error) {
        console.error("Error fetching products: ", error);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div className="bg-gray-50 min-h-screen py-8 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 text-gray-800">
        All Products
      </h1>

      <div className="grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 max-w-7xl mx-auto">
        {products.map((product) => {
          console.log("Product ID:", product.id); // 👈 Console log to verify product.id
          return (
            <div
              key={product.id}
              className="bg-white shadow-md rounded-2xl overflow-hidden hover:shadow-lg transition-all duration-300 flex flex-col"
            >
              <Link to={`/product/${product.id}`}>
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-48 sm:h-52 object-cover"
                />
              </Link>

              <div className="p-4 flex flex-col justify-between flex-grow">
                <div>
                  <h2 className="text-base sm:text-lg font-semibold text-gray-800">
                    {product.name}
                  </h2>
                  <p className="text-sm text-gray-500 mt-1 mb-2">
                    {product.shortDescription}
                  </p>
                  <p className="text-sm sm:text-base font-bold text-pink-600 mb-3">
                    ₹{product.price}
                  </p>
                </div>
                <Link
                  to={`/product/${product.id}`}
                  className="mt-auto bg-rose-600 text-white text-center px-4 py-2 rounded-full text-sm hover:bg-rose-700 transition"
                >
                  View Details
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AllProducts;
